export default "__VITE_ASSET__A1jEYbY9__"